export default {
	methods: {
		splitArray(array, count) {
			var top = [];
			var bottom = [];
			for (let i = 0; i < array.length; i++) {
				if (i < count) {
					top.push(array[i]);
				}
				else {
					bottom.push(array[i]);
				}
			}
			return {
				top,
				bottom
			};
		},
		splitArrayLast(array, count) {
			var top = [];
			var bottom = [];
			let hidedCount = array.length - count;
			for (let i = 0; i < array.length; i++) {
				array[i].index = i;
				if (i < hidedCount) {
					top.push(array[i]);
				}
				else {
					bottom.push(array[i]);
				}
			}
			return {
				top,
				bottom
			};
		},
	}
};
